module.exports = __webpack_public_path__ + "img/avatar5.513f4f42.png";